import { useCallback } from 'react'
import { useSlate } from 'slate-react'

import { Button } from 'core-components/library/button'
import { Menu } from 'core-components/library/menu'
import { TPopupHorizontal } from 'core-components/library/popup'
import { insertColumns } from 'core-components/library/richTextEditor/helpers/slateHelper'
import {
  COLUMN_FORMATS,
  COLUMN_TYPES,
} from 'core-components/library/richTextEditor/interface/custom-types'
import { TOOLBAR_BUTTONS } from 'core-components/library/richTextEditor/interface/IToolbar'
import { Tooltip } from 'core-components/library/tooltip'
import { BaseCrud, Static } from 'core-components/types'

import { TOOLBAR_TITLES } from '../../constants'

interface IProps {
  disabled: boolean
  className?: string
}

export const ColumnOptionsButton = (props: IProps) => {
  const editor = useSlate()
  const columnOptions = COLUMN_TYPES.map((item) => ({
    key: item.style,
    label: item.label,
    icon: item.icon,
  }))
  const source = new BaseCrud({
    fetcher: new Static(columnOptions),
    keyField: 'key',
  })

  const onChoose = useCallback((variant: string) => {
    insertColumns(editor, variant as COLUMN_FORMATS)
  }, [])

  return (
    <Menu
      content={() => (
        <Button
          className={props.className}
          disabled={props.disabled}
          iconButton="kbase kbase-editor-columns-half"
          title={TOOLBAR_TITLES[TOOLBAR_BUTTONS.ColumnOptions]}
          variant={'text'}
          color={'grey'}
        />
      )}
      onChoose={onChoose}
      source={source}
      itemTpl={(item) => {
        return (
          <Tooltip
            tipContent={() => <>{item.label}</>}
            horizontalStartPosition={TPopupHorizontal.Right}
            horizontalDirection={TPopupHorizontal.Right}
          >
            <i className={item.icon} />
          </Tooltip>
        )
      }}
    />
  )
}
